(() => {
  const form = document.querySelector('[data-sb-footer-signup]');
  if (!form) return;

  const emailInput = form.querySelector('[data-sb-footer-signup-email]');
  const submitButton = form.querySelector('[data-sb-footer-signup-submit]');
  const successNode = document.querySelector('[data-sb-footer-signup-success]');
  const errorNode = document.querySelector('[data-sb-footer-signup-error]');
  const errorTextNode = errorNode?.querySelector('[data-sb-footer-signup-error-text]');

  const setError = (message) => {
    form.classList.toggle('is-error', Boolean(message));
    if (message && successNode) successNode.hidden = true;
    if (!errorNode) return;
    if (errorTextNode) errorTextNode.textContent = message || '';
    errorNode.hidden = !message;
  };

  // A footer signup also silences the welcome popup for good - both
  // components share this localStorage record.
  const rememberSubscribed = () => {
    try {
      const memory = JSON.parse(window.localStorage.getItem('sb-signup-popup')) || {};
      window.localStorage.setItem('sb-signup-popup', JSON.stringify({ ...memory, subscribed: true }));
    } catch (_) {}
  };

  const subscribe = async (email) => {
    const companyId = `${form.dataset.companyId || ''}`.trim();
    const listId = `${form.dataset.listId || ''}`.trim();

    if (!companyId || !listId) return false;

    const response = await fetch(
      `https://a.klaviyo.com/client/subscriptions/?company_id=${encodeURIComponent(companyId)}`,
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', revision: '2026-04-15' },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: `${form.dataset.customSource || 'Shopify footer form'}`,
              profile: { data: { type: 'profile', attributes: { email } } },
            },
            relationships: { list: { data: { type: 'list', id: listId } } },
          },
        }),
      }
    );
    if (!response.ok && response.status !== 202) return false;

    try {
      if (typeof window.klaviyo?.identify === 'function') {
        Promise.resolve(window.klaviyo.identify({ email })).catch(() => {});
      } else if (Array.isArray(window._learnq)) {
        window._learnq.push(['identify', { email }]);
      }
    } catch (_) {}
    return true;
  };

  // Same signup metric the popup fires, distinguished by source. Fire and
  // forget; the data-track-signup attribute only renders on the published
  // theme, keeping test submits out.
  const trackSignupEvent = async (email) => {
    const companyId = `${form.dataset.companyId || ''}`.trim();
    if (!companyId || !form.hasAttribute('data-track-signup')) return;
    try {
      await fetch(`https://a.klaviyo.com/client/events/?company_id=${encodeURIComponent(companyId)}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', revision: '2026-04-15' },
        body: JSON.stringify({
          data: {
            type: 'event',
            attributes: {
              properties: {
                source: 'footer',
                page: window.location.href,
                device_type: window.matchMedia('(max-width: 749px)').matches ? 'mobile' : 'desktop',
              },
              metric: { data: { type: 'metric', attributes: { name: 'soundbrenner.com signup' } } },
              profile: { data: { type: 'profile', attributes: { email } } },
            },
          },
        }),
      });
    } catch (_) {}
  };

  emailInput?.addEventListener('input', () => {
    if (form.classList.contains('is-error')) setError('');
  });

  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    if (submitButton?.disabled) return;
    const email = `${emailInput?.value || ''}`.trim();
    if (!email) return setError(form.dataset.errorRequired);
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) {
      return setError(form.dataset.errorInvalid);
    }

    setError('');
    submitButton?.classList.add('is-loading');
    if (submitButton) submitButton.disabled = true;
    try {
      const ok = await subscribe(email);
      if (!ok) return setError(form.dataset.errorGeneric);
      rememberSubscribed();
      trackSignupEvent(email);
      form.classList.add('is-success');
      if (emailInput) emailInput.value = '';
      if (successNode) successNode.hidden = false;
    } catch (_) {
      setError(form.dataset.errorGeneric);
    } finally {
      submitButton?.classList.remove('is-loading');
      if (submitButton) submitButton.disabled = false;
    }
  });
})();
